import { Link } from 'react-router-dom';
import '../LandingPage/LandingPage2.css';
import Carousel from './Carousel/Carousel';
import './Showroom.css'
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
// Import the JSON file
import imageUrls from './pics.json'
function Showroom() {
    // Convert URL array to carousel image format
    const carouselImages = imageUrls.map((url, index) => ({
        src: url,
        alt: `Engineering Cubes Project ${index + 1}`,
        caption: '' // Add captions if needed
    }));

    return (
        <div className='Entire-Showroom'>
            {/* Top Section */}
            <Navbar/>

            {/* Middle Section - Carousel */}
            <div className="showroom-carousel-section">
                <h2 className="carousel-title">Welcome to the showroom.</h2>
                <Carousel images={carouselImages} autoScrollInterval={5000} />
            </div>

            {/* Bottom Section */}
            <Footer/>
        </div>
    );
}

export default Showroom;